import React from 'react';
import { Link } from 'react-router-dom';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service like Sentry
    console.error("Uncaught error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-black text-white flex flex-col items-center justify-center px-6 text-center font-sans">
          <div className="max-w-2xl">
            <h1 className="text-4xl md:text-6xl font-black mb-6 uppercase tracking-tighter italic">
              Runtime <span className="text-red-500 underline decoration-2 decoration-red-500/50">Anomaly</span>
            </h1>
            <p className="text-gray-400 text-lg mb-8 font-mono leading-relaxed max-w-lg mx-auto">
              [ ERROR_REPORT ]: Component level failure detected. This is typically caused by unhandled logic spikes or corrupted state.
            </p>
            
            <div className="bg-red-500/10 border border-red-500/30 p-4 mb-10 rounded font-mono text-sm text-red-100 overflow-auto max-h-[150px] text-left">
               {this.state.error && this.state.error.toString()}
            </div>

            <button 
              onClick={() => window.location.reload()}
              className="inline-flex items-center justify-center px-10 py-4 bg-white text-black font-extrabold uppercase tracking-widest text-sm hover:bg-[#CCFF00] transition-all"
            >
              Force Reboot Initialization
            </button>
            
            <div className="mt-6 text-gray-500 text-xs">
              <Link to="/" className="hover:text-white underline decoration-[#CCFF00] underline-offset-4 decoration-2">Return to Safety Vector Index</Link>
            </div>
          </div>
          
          {/* Subtle decoration as background element */}
          <div className="absolute top-0 left-0 w-full h-1 bg-red-500 opacity-50" />
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
